import { Link } from 'react-router-dom';
import itinluxLogo from '../public/images/logo1.png';
import itinluxLogoWhite from '../public/images/logo_black.png';

interface LogoProps {
  /** Size of the logo */
  size?: 'sm' | 'md' | 'lg' | 'xl';
  /** Theme variant - light logo for dark backgrounds, dark logo for light backgrounds */
  variant?: 'light' | 'dark';
  /** Optional custom className */
  className?: string;
  /** Whether the logo should be clickable (default: true) */
  clickable?: boolean;
}

const sizeClasses = {
  sm: 'h-[24px] sm:h-[30px]',
  md: 'h-[30px] sm:h-[40px] lg:h-[50px]',
  lg: 'h-[40px] sm:h-[50px] lg:h-[60px]',
  xl: 'h-[70px] sm:h-[85px] lg:h-[100px]'
};

export function Logo({ 
  size = 'md', 
  variant = 'dark', 
  className = '', 
  clickable = true 
}: LogoProps) {
  const logoClasses = [
    'w-auto object-contain',
    sizeClasses[size],
    className
  ].filter(Boolean).join(' ');

  const containerClasses = clickable 
    ? 'flex items-center hover:opacity-80 transition-opacity' 
    : 'flex items-center';

  // Use the appropriate logo image based on variant
  const logoSrc = variant === 'light' ? itinluxLogoWhite : itinluxLogo;

  const logoElement = (
    <img 
      src={logoSrc} 
      alt="ItinLuX - Luxury Travel Blog" 
      className={logoClasses}
      width="150"
      height="50"
      loading="eager"
    />
  );

  if (!clickable) {
    return (
      <div className={containerClasses} role="img" aria-label="ItinLuX logo">
        {logoElement}
      </div>
    );
  }

  return (
    <Link 
      to="/" 
      className={containerClasses}
      aria-label="ItinLuX - Return to homepage"
    >
      {logoElement}
    </Link>
  );
}

export default Logo;